import React, { useContext, useState } from 'react';
import { map } from 'lodash';
import { fraudContext } from '../../../contexts';
import { onPasteDetected, prepareParams, sendToFraudCheck } from '../../../logic/fraud_check';
import ZoomImage from '../../zoom_image';
import FooterButton from '../../footer_button';
import TextWithImages from '../../textWithImages';
import renderRawHtml from '../../../../../../common/render_raw_html';

const Reason = ({
  question, answers, nextStep, result, mainResult,
  forceImage = false, productDescriptionComponent = null, concept = null
}) => {
  let header;
  if (productDescriptionComponent && concept) {
    header = (
      <div className="survey-header">
        <div className="survey-header_title">
          <h3 className="survey-name-label -normal" { ...renderRawHtml(concept.name) } />
          { productDescriptionComponent }
        </div>
      </div>
    );
  } else {
    header = (<></>);
  }

  const { respondentId, projectId, antiFraud, setFraudProcessing } = useContext(fraudContext);
  const [ text, updateText ] = useState("");

  const disabledOption = () => {
    const hash = {};
    if (!text) {
      hash.disabled = 'disabled';
    }
    return hash;
  };

  const processAnswer = () => {
    if (result.answers) {
      result.answers.push({ [question.name]: text });
    } else {
      result[question.name] = text;
    }
    updateText('');
    const fraudParams = prepareParams(
      { antiFraud, projectId, respondentId },
      [ text ]
    );
    sendToFraudCheck(fraudParams, nextStep, setFraudProcessing);
  };

  const updateAnswer = (event) => {
    updateText(event.target.value);
  };

  let wrapperClassName = answers.length > 1 ? '-half-width' : '';
  if (answers.length >= 3) {
    wrapperClassName = '-third-width';
  }

  return (
    <>
      { header }
      <div className="survey-layout_content">
        <div className="survey-layout_container -reason">
          <div className="survey-options">
            {
              ((!header || (forceImage && !!concept?.url))) &&
              <div className="survey-options_image-plate">
                <ZoomImage
                  className="survey-options_image"
                  src={ concept.url }
                >
                  <img src={ concept.url } />
                </ZoomImage>
              </div>
            }
            <div className="survey-options_image-plate -reason">
              {
                map(answers, (answer) => (
                  <ZoomImage
                    key={ answer.id }
                    withHeadWrapper
                    className="survey-options_image"
                    src={ answer.imageUrl }
                    textAsSrc={ answer.text }
                    wrapperClassName={ wrapperClassName }
                  />
                ))
              }
            </div>
            <div className="note survey-options_question -reason survey-options_question-reason-title -center">
              <TextWithImages
                className="survey-options_question-title-inner"
                content={ question.text }
              />
            </div>
            <textarea
              className="js-text form-field -reason"
              onChange={ (e) => { updateAnswer(e); } }
              onPaste={ () => { onPasteDetected(mainResult); } }
            />
          </div>
        </div>
      </div>
      <div className="survey-footer">
        <FooterButton nextStep={ () => { processAnswer(); } } options={ disabledOption() } />
      </div>
    </>
  );
};

export default Reason;
